"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Message=void 0;const Message=exports.Message=_styledComponents.default.div`
z-index: 10;
display: flex;
padding: 12px 16px;
gap: 10px;
background: #FAF9F8;
border-radius: 8px;
margin-bottom: 16px;
/* width: ${a=>a?.info?"880px":"660px"}; */
width: ${a=>"giftCardScreen"===a?.shownFrom?"auto":a?.info?"880px":"660px"};
&.success{
    border: 1px solid #8BD9B3;
    justify-content:space-between;
    align-items: center;
}
&.errorMsg{
    border: 1px solid #FBB5B5;
}
&.warnMsg{
    border: 1px solid #F7D171; 
    justify-content:space-between;
    align-items: center;
}
&.mobile{
    /* width: 336px; */
    width: ${a=>"giftCardScreen"==a?.shownFrom?"auto":"336px"};
    box-sizing: border-box;
} 
.image{
    height:21px;
    align-self: center;
    mix-blend-mode: darken;
    opacity: 1 !important;
}
.marginLeft{
    margin-left:9px;
}
.center{
    display:flex;
    padding-left: 1px;
    padding-right: 1px;
}
}
.close:hover{
    cursor:pointer;
    opacity: 1 !important;
}

.fpStyle{
    color:black;
    font-weight:600;
    text-decoration: underline;
}

&.alertMsg{
    border: 1px solid #B3D3EB;
    align-items: center;
    font-weight: 400;
    font-size: 12px;
    line-height: 21px;
}
`;